import { defineStore } from "pinia";
import { api } from "@/helpers/api.js";
import { todayISODate } from "@/helpers/format";

const SPORT_TYPE_NAME = {
  soccer: "Football",
  horseracing: "Horse racing",
  formula1: "Formula 1",
  motogp: "MotoGP",
  nba: "NBA",
  nfl: "NFL",
  mlb: "MLB",
  dtm: "DTM",
  ufc: "UFC",
  rugby: "Rugby",
  icehockey: "Ice hockey",
  watersport: "Water sport",
  boxing: "Boxing",
  darts: "Darts",
  indycar: "IndyCar",
  superbike: "SuperBike",
};

export const lookupSportTypeName = (sport_type) =>
  SPORT_TYPE_NAME[sport_type] || sport_type[0].toUpperCase() + sport_type.slice(1);

export const useSportTypesStore = defineStore("sport_types", {
  state: () => ({
    data: null,
    req: null,
  }),
  getters: {
    sport_types() {
      if (!this.data) {
        this.data = [];
        this.fetch();
      }
      return this.data;
    },
    ready() {
      return this.sport_types && this.req;
    },
  },
  actions: {
    fetch() {
      this.req = api.cache("/tournaments?page_size=9999&date_stop=ge:" + todayISODate).then((res) => {
        const index = {};
        res.data.tournaments.forEach((tournament) => {
          const sport_type = tournament.sport_type;
          const sport_type_name = lookupSportTypeName(sport_type);
          if (sport_type in index) {
            index[sport_type].tournaments.push({
              ...tournament,
              sport_type_name,
            });
          } else {
            index[sport_type] = {
              sport_type,
              sport_type_name,
              tournaments: [
                {
                  ...tournament,
                  sport_type_name,
                  uc: (tournament.official_name + " " + sport_type_name).toUpperCase(),
                },
              ],
            };
          }
        });
        this.data = Object.values(index);
      });
    },
    getTournament(slug) {
      for (const sportType of this.sport_types) {
        for (const tournament of sportType.tournaments) {
          if (tournament.slug === slug) {
            return tournament;
          }
        }
      }
    },
    async get_tournaments(query, next) {
      query.sport_type = query.sport_type.replace("football", "soccer");

      const params = new URLSearchParams({
        page_size: 9999,
        date_stop: "ge:" + todayISODate,
        ...query,
      });

      const req = api.cache("/tournaments?" + params);
      // console.log('/tournaments?' + params)
      const res = await req;
      next(res.data.tournaments.filter((x) => x.number_events));
    },
  },
});
